/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from 'lodash'
import axios from 'axios'
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js'; // Required for BS4
import 'bootstrap';
import 'datatables.net';
import 'datatables.net-bs4';
import 'select2';
import moment from 'moment';
import 'moment-timezone';
import 'eonasdan-bootstrap-datetimepicker-bootstrap4beta';
import intlTelInput from 'intl-tel-input';
import 'jquery-validation';
import '../../node_modules/jquery-validation/dist/additional-methods.js';
import Inputmask from "inputmask";
import { v4 as uuidv4 } from 'uuid';
require('tinymce');
import 'daterangepicker';
import 'malihu-custom-scrollbar-plugin';
import 'jquery-mousewheel';
import toastr from 'toastr';
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.moment = moment;
window.intlTelInput = intlTelInput;
window.$ = window.jQuery = $;
window.Swal = Swal;
window.toastr = toastr;
window.inputmask = Inputmask;
window.uuid = uuidv4;
window._ = _; // Lodash

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
